module.exports = __webpack_public_path__ + "static/media/Logo_1.cc065a38.png";